import * as yup from "yup";
import { TFunction } from "i18next";

const FORBIDDEN_NAME_CHARS = /[№"!#$%^\&*\/\[\]|}{)(+=,±;'?:<>’»@]/g;

export const getYupSchemaForManageReportForm = (t: TFunction) => {
  return yup.object().shape({
    name: yup
      .string()
      .transform((value) =>
        typeof value === "string"
          ? value.replace(FORBIDDEN_NAME_CHARS, "")
          : value,
      )
      .required(t("validation.required"))
      .max(250, t("validation.more250")),
    indicators: yup.array().min(1, t("validation.required")),
    dealerFields: yup.array().min(1, t("validation.required")),
  });
};
